/** Anzeigetitel ohne vorangestellten Klientennamen ("<Name> – Titel" bzw. "Nachname, Vorname – Titel" -> "Titel"). */
export function ohneKlient(titel, klientName) {
  const t = String(titel || '');
  const i = t.indexOf(' – ');
  if (i <= 0) return t;
  const kopf = t.slice(0, i).trim();
  const name = String(klientName || '').trim();
  return kopf.includes(',') || (name && kopf === name) ? t.slice(i + 3) : t;
}
